const POITitle = ({ title }) => (
    <div className="container main">
        <div className="details">
            <h1 className="text-center">{title}</h1>
        </div>
    </div>
)

export default POITitle
